<template>
    <div class="container">
        <div>
            <div class="article-info">
                <div class="title" >
                    <span>{{qaItem.title}}</span>
                </div>
                <div class="commentStyle" >
                    <span>{{ qaItem.likeCount }}人觉得很赞</span>
                </div>
                <div class="contentStyle" >
                    <span v-html="qaItem.question"></span>
                    <span style="color:#F72B17" @click="goVideoInfo('/answerInfo', qaItem.id)"> 阅读原文
                      <i class="el-icon-arrow-down" style="color:#F72B17"></i>
                    </span>
                </div>
                <div class="articleDesc" >
                    <div style="padding:0px 0 0 0px;color:#BBBBBB;">
                        <span class="iconfont" style="margin-right:4px;font-size: 18px;vertical-align: middle">&#xe7fd;</span>
                        <span class="iconStyle">{{ qaItem.readCount }}</span>
                        <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle;font-size:16px">&#xe690;</span>
                        <span class="iconStyle">{{ qaItem.commentCount }}</span>

                        <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe603;</span>
                        <span class="iconStyle">{{ qaItem.collectCount }}</span>

                      <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle;font-size:16px">&#xe636;</span>
                      <span class="iconStyle" v-if="qaItem.status==0">审核中</span>
                      <span class="iconStyle" v-if="qaItem.status==1">通过</span>
                      <span class="iconStyle" v-if="qaItem.status==2" style="color: red" :title="qaItem.checkSuggest">未通过</span>
                      <span class="iconStyle" v-if="qaItem.status==3">下架</span>
                      <span class="iconStyle" v-if="qaItem.status==4">草稿</span>

                        <span v-show="linkFrom == 'creative'">
                          <span @click="deleteQuestion(qaItem.id)">
                            <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe61e;</span>
                            <span class="iconStyle">删除</span>
                          </span>
                          <span @click="editQuestion(qaItem.id)">
                            <span class="iconfont" style="margin:0 4px 0 20px;vertical-align: middle">&#xe690;</span>
                            <span class="iconStyle">编辑</span>
                          </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {delQuestion} from "@/comm/api";

export default {
  name: 'ManagerArticleV',
  components: {

  },
  props:{
    qaItem:{},
    hasImg:{
        type:String,
        default:'no'
      },
    collection:{
      type:Boolean,
      default:false,
    },
    linkFrom:{
      type:String,
      default:'',
    }
  },
 methods: {
    goVideoInfo(url, id) {
      const { href } = this.$router.resolve({
        path: url+"?id="+id
      });
      window.open(href, "_blank");
    },
   async deleteQuestion(id){
      await delQuestion({id:id})
      this.$emit("submit-loadPage");
     this.$message.success('删除成功');
    },
    editQuestion(id){
    //TODO 跳转编辑页面
      let routeData = this.$router.resolve({ path: '/creativeCenter', query: {"viewKey": "4-4","resourceId":id } });
      window.open(routeData.href, '_blank');
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="stylus" scoped>
    .container
        width 96%;
        background white;
        border-radius 4px;
        cursor pointer;
        padding:15px 0 0px 0;

        .img
            width 206;
            height 116px;
            border-radius 4px 4px 0px 0px;
        .article-info
            //  margin-top:-5px;
            //  padding:15px 10px;
            //  background :#f4f4f5;
            .title
                font-size: 18px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 25px;
                padding-top:5px;
            .commentStyle{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #F72B17;
                line-height: 20px;
                padding-top:10px;
            }
            .contentStyle{
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 21px;
                padding-top :10px;
            }
            .articleDesc
                font-size: 12px;
                font-weight: 400;
                color: #B8B9BA;
                line-height: 17px;
                margin-top 10px;
                text-align :left;
                padding-bottom:20px;border-bottom: 1px solid #EEEEEE;

                .iconStyle{
                    padding:0 3px;
                }
        .article-info-haveImg
            display :flex;
            justify-content :flex-start;
            .title
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align:left;
.toolDiv{
    background: #fff;
    padding-bottom:15px;
    margin-top:10px;
    background :#f4f4f5;
    width:100%;
    .tool{
        padding-right:3px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #b8b9ba;
        line-height: 20px;
        height :20px;
    }
}
</style>
